import { render, staticRenderFns } from "./CompanyUrlLandingPage.vue?vue&type=template&id=1c1f6b8c"
import script from "./CompanyUrlLandingPage.vue?vue&type=script&lang=js"
export * from "./CompanyUrlLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports